import { getCardType } from './get-card-type.js';
import { isParentWrapped } from './is-parent-wrapped.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';

var getParentClasses = function getParentClasses(args) {
  var width = args.width,
      type = args.type,
      mediaSize = args.mediaSize,
      mediaPosition = args.mediaPosition,
      cardWidth = args.cardWidth;
  var cardType = getCardType(width, type);
  var largeMedia = mediaSize === 'large';
  var parentWrapped = isParentWrapped({
    largeMedia: largeMedia,
    mediaPosition: mediaPosition,
    cardWidth: cardWidth
  });
  return _formatClassName(['card-parent', "card-parent-".concat(cardType), {
    'card-parent-wrapped': parentWrapped
  }]);
};

export { getParentClasses };